import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

function NotFound() {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center px-4">
      <div className="max-w-4xl mx-auto text-center">
        {/* Animated 404 */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#2F5496] to-purple-600 animate-pulse">
            404
          </h1>
          <div className="relative">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-32 h-32 border-4 border-[#2F5496] border-opacity-30 rounded-full animate-spin"></div>
              <div className="absolute w-24 h-24 border-4 border-purple-500 border-opacity-30 rounded-full animate-spin" style={{animationDirection: 'reverse', animationDuration: '3s'}}></div>
            </div>
          </div>
        </div>

        {/* Main Message */}
        <div className="mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Oops! Página <span className="text-[#2F5496]">Perdida</span> no Espaço Digital
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
            Parece que esta página se aventurou em uma jornada intergaláctica e ainda não retornou. 
            Não se preocupe, nossos exploradores digitais estão em busca dela!
          </p>
        </div>

        {/* Fun Illustration */}
        <div className="mb-12">
          <div className="relative inline-block">
            <div className="text-8xl mb-4 animate-bounce">🚀</div>
            <div className="absolute -top-4 -right-4 text-4xl animate-ping">✨</div>
            <div className="absolute -bottom-2 -left-4 text-3xl animate-pulse">🌟</div>
            <div className="absolute top-8 -left-8 text-2xl animate-bounce" style={{animationDelay: '0.5s'}}>🛸</div>
          </div>
        </div>

        {/* Error Details */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8 border border-gray-100">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-red-100 to-red-200 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:rotate-12 transition-transform duration-300">
                <span className="text-2xl">🔍</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Exploração Completa</h3>
              <p className="text-gray-600 text-sm">Procuramos em todos os cantos do universo digital</p>
            </div>
            
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-100 to-yellow-200 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:rotate-12 transition-transform duration-300">
                <span className="text-2xl">📡</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Sinal Perdido</h3>
              <p className="text-gray-600 text-sm">A página pode ter mudado de frequência</p>
            </div>
            
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-green-100 to-green-200 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:rotate-12 transition-transform duration-300">
                <span className="text-2xl">🔄</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Retorno Programado</h3>
              <p className="text-gray-600 text-sm">Nossos engenheiros estão trabalhando no resgate</p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/" 
            className="bg-[#2F5496] text-white font-bold text-lg px-8 py-4 rounded-lg hover:bg-[#1e40af] transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
          >
            🏠 Voltar ao Lar
          </Link>
          <Link 
            to="/services" 
            className="bg-transparent border-2 border-[#2F5496] text-[#2F5496] font-bold text-lg px-8 py-4 rounded-lg hover:bg-[#2F5496] hover:text-white transition-all duration-300 transform hover:scale-105"
          >
            🚀 Explorar Serviços
          </Link>
          <Link 
            to="/contact" 
            className="bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold text-lg px-8 py-4 rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
          >
            📞 Pedir Socorro
          </Link>
        </div>

        {/* Fun Facts */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm mb-4">💡 Curiosidade do Dia:</p>
          <p className="text-gray-600 text-lg italic">
            "A primeira página 404 foi criada em 1992, quando um servidor web não conseguiu encontrar uma página chamada '404.html'"
          </p>
        </div>

        {/* Floating Elements */}
        <div className="fixed inset-0 pointer-events-none overflow-hidden">
          <div className="absolute top-20 left-10 w-4 h-4 bg-[#2F5496] rounded-full opacity-20 animate-ping"></div>
          <div className="absolute top-40 right-20 w-6 h-6 bg-purple-500 rounded-full opacity-30 animate-bounce" style={{animationDelay: '1s'}}></div>
          <div className="absolute bottom-40 left-20 w-3 h-3 bg-pink-500 rounded-full opacity-40 animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-5 h-5 bg-blue-500 rounded-full opacity-25 animate-ping" style={{animationDelay: '2s'}}></div>
        </div>
      </div>
    </div>
  )
}

export default NotFound

